(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('channel-conf', {
            parent: 'entity',
            url: '/channel-conf?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.channelConf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/channel-conf/channel-confs.html',
                    controller: 'ChannelConfController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('channel-conf-detail', {
            parent: 'entity',
            url: '/channel-conf/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPER_ADMIN'],
                authenticate: true,
                pageTitle: 'wamasysApp.channelConf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/channel-conf/channel-conf-detail.html',
                    controller: 'ChannelConfDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ChannelConf', function($stateParams, ChannelConf) {
                    return ChannelConf.get({id : $stateParams.id});
                }]
            }
        })
        .state('channel-conf.new', {
            parent: 'channel-conf',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/channel-conf/channel-conf-dialog.html',
                    controller: 'ChannelConfDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('channel-conf', null, { reload: true });
                }, function() {
                    $state.go('channel-conf');
                });
            }]
        })
        .state('channel-conf.edit', {
            parent: 'channel-conf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/channel-conf/channel-conf-dialog.html',
                    controller: 'ChannelConfDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChannelConf', function(ChannelConf) {
                            return ChannelConf.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('channel-conf', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('channel-conf.delete', {
            parent: 'channel-conf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/channel-conf/channel-conf-delete-dialog.html',
                    controller: 'ChannelConfDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChannelConf', function(ChannelConf) {
                            return ChannelConf.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('channel-conf', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('channel-conf.test-message', {
                parent: 'channel-conf',
                url: '/{id}/test-message',
                data: {
                    authorities: ['ROLE_SUPER_ADMIN','ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/business/channel-conf/channel-conf-test-message-dialog.html',
                            controller: 'ChannelConfTestMessageDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                channelConfId: function() { return $stateParams.id; }
                            }
                        }).result.then(function() {
                            $state.go('channel-conf', null, { reload: false });
                        }, function() {
                            $state.go('^');
                        });
                    }
                ]
            })
        
        
        ;
    }

})();
